import { IExportColumnModel } from "../../../../../shared/models";

export const ScopesColumnList: IExportColumnModel[] = [
]